import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getRankConfig = createAsyncThunk(
  'unionBattleA/getRankConfig',
  async (e: any, store: any) => {
    const resp = await http.post('/live/activity/union_upgrade_match_detail', {
      ...store.getState().env.deviceinfo,
      ...e,
    })
    return resp.data
  }
)
export const getRankStage = createAsyncThunk(
  'unionBattleA/getRankStage',
  async (e, store: any) => {
    const resp = await http.post('/live/activity/union_upgrade_match_stage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
const initialState: {
  is_match_union: boolean
  union_id: number
  union_name: string
  rank: number
  score: number
  avatar: string
  distance: number
  rank_list: Array<{
    group: string
    list: Array<{
      union_id: number
      union_name: string
      rank: number
      score: number
      avatar: string
    }>
  }>
  count_down: number
  stage: number // 非中东 1 海选赛 2淘汰赛 3pk赛 4冲刺赛， 中东1 海选赛 2淘汰赛 3冲刺赛
  notify_list: Array<string>
} = {
  is_match_union: false,
  union_id: 0,
  union_name: '',
  rank: 0,
  score: 0,
  distance: 0,
  rank_list: [],
  count_down: 0,
  avatar: '',
  stage: 1,
  notify_list: [],
}

export const unionBattleASlice = createSlice({
  name: 'rankTask',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRankConfig.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getRankStage.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})
export default unionBattleASlice.reducer
